export default __webpack_public_path__ + "static/media/eylul.67b39dad.png";